import React, { useState } from "react";
import "../styles/Intro.css";
import introimage from "../assets/MyImage.svg";
import line1 from "../assets/Line 1.svg";
import line2 from "../assets/Line 2.svg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin, faSquareGithub } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";

function Intro() {
  const [offset, setOffset] = useState({ x: 0, y: 0 });

  const handleMouseMove = (e) => {
    const rect = e.currentTarget.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width - 0.9) * 20;
    const y = ((e.clientY - rect.top) / rect.height - 0.9) * 20;
    setOffset({ x, y });
  };

  const handleMouseLeave = () => {
    setOffset({ x: 0, y: 0 });
  };

  return (
    <section id="intro">
      <div className="intro-container">
        <img src={line2} alt="Dotted line" class="dotted-line-right" />
        <div class="text-block-right">
          <h1 class="line-text-right">Hi, I'm Christina!</h1>
        </div>

        <div
          className="graphic-overlay"
          onMouseMove={handleMouseMove}
          onMouseLeave={handleMouseLeave}
        >
          <img
            src={introimage}
            alt="graphic"
            class="circle-photo"
            style={{
              transform: `translate(${offset.x}px, ${offset.y}px)`,
              transition: "transform 0.1s ease-out",
            }}
          />
        </div>

        <img src={line1} alt="Dotted line" class="dotted-line-left" />
        <div class="text-block-left">
          <p class="line-text-left">
            I'm a developer and designer studying{" "}
            <strong>Computer Science</strong> and <strong>Art Practice</strong>{" "}
            at Stanford University.
          </p>
          <div class="icons-container">
            <FontAwesomeIcon
              icon={faLinkedin}
              size="2x"
              className="icon-button"
              onClick={() =>
                window.open("https://www.linkedin.com/in/christinaba/")
              }
            />
            <FontAwesomeIcon
              icon={faEnvelope}
              size="2x"
              className="icon-button"
              onClick={() => window.open("mailto:cba1@stanford.edu")}
            />
            <FontAwesomeIcon
              icon={faSquareGithub}
              size="2x"
              className="icon-button"
              onClick={() => window.open("https://github.com/christinaba24")}
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Intro;
